var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-header"
  }, [_c('content-wrapper', [_c('main-logo', {
    staticClass: "header-logo"
  }), _vm._v(" "), _c('main-menu', {
    staticClass: "header-menu"
  }), _vm._v(" "), _c('search-box', {
    staticClass: "header-search"
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-def3f26e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/page-header/page-header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-def3f26e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/page-header/page-header.vue
// module chunks = index